import { Card } from '@/components/ui/Card';

export function SettingsPage() {
  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <header>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-gold-500">Settings</p>
        <h1 className="mt-2 display-serif text-display-l text-fg">Site settings</h1>
        <p className="mt-2 text-sm text-fg-muted">Analytics, email sender, theme defaults.</p>
      </header>

      <Card className="p-6">
        <p className="text-sm text-fg-muted">
          Brand, contact, social, nav, footer, and SEO settings live on the <strong>Site</strong> page. This page
          is reserved for environment-level toggles (analytics, sender identity, scheduled-job status) — wired up
          once the project is on Supabase + Cloudflare in production.
        </p>
      </Card>
    </div>
  );
}